import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class NotificationService {

    users = new Array();
    private currentUsersSubject = new BehaviorSubject<any[]>([]);
    public currentUsers = this.currentUsersSubject.asObservable();
    public audio = new Audio('assets/alarm.mp3');


    constructor() {
        this.audio.load();
    }

    addUserAlarm(user) {
        this.audio.play();
        this.audio.loop = true;

        if (this.users.findIndex(j => j.alarmID === user.alarmID) === -1) {
            this.users.push(user);
            this.currentUsersSubject.next(this.users);
        }
    }


    deleteUserAlarm(user) {
        this.stopAlarm();
        const userIndex = this.users.findIndex(j => j.alarmID == user.alarmID);
        if (userIndex >= 0) {
            this.users.splice(userIndex, 1);
            this.currentUsersSubject.next(this.users);
        }

        // if (this.users.length === 0) {
        //    this.audio.pause();
        // }
    }

    clean() {
        this.users = [];
        this.audio.pause();
        this.currentUsersSubject.next(this.users);
    }

    stopAlarm() {
        this.audio.pause();
    }

    getAlarmUsers(): Observable<any> {
        return this.currentUsers;
    }

    getAlarmArray() {
        return this.users;
    }

    muteAlarm(result) {
        this.audio.muted = result;
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/notification.service.ts